import React from "react";
import Translate from "react-translate-component";
import FormattedAsset from "../../Utility/FormattedAsset";
export const BondClaimCollaterial = ({
  op,
  linkToAccount,
  current
}) => {
  if (current === op[1].lender) {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.bond_pay_collateral"
    }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
      style: {
        fontWeight: "bold"
      },
      amount: op[1].collateral_claimed.amount,
      asset: op[1].collateral_claimed.asset_id
    }), /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.to"
    }), "\xA0", linkToAccount(op[1].claimer));
  } else if (current === op[1].claimer) {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.bond_claim_collateral"
    }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
      style: {
        fontWeight: "bold"
      },
      amount: op[1].collateral_claimed.amount,
      asset: op[1].collateral_claimed.asset_id
    }), /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.from"
    }), "\xA0", linkToAccount(op[1].lender));
  } else {
    return null;
  }
};